var _rect, _rect2, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMiniExercise01(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 259,
    height: 253,
    viewBox: "0 0 259 253",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.671875,
    y: 0.453125,
    width: 258,
    height: 252,
    fill: "#87B1B4"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_485_19501",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 259,
    height: 253
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.671875,
    y: 0.453125,
    width: 258,
    height: 252,
    fill: "#4A5294"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_485_19501)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 126.468,
    y: 192.953,
    width: 193.576,
    height: 14.1898,
    rx: 2,
    transform: "rotate(-47.4489 126.468 192.953)",
    fill: "#FFC7C7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.353 58.5952L258.846 51.7043C258.033 50.9574 256.768 51.0115 256.021 51.8252L252.841 55.2891C252.696 55.4472 252.588 55.6042 252.498 55.7991C245.969 69.9497 205.596 127.738 174.76 161.33L266.474 61.421C267.221 60.6073 267.167 59.3421 266.353 58.5952Z",
    fill: "#EFA7A7"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 176.125,
    y: 138.213,
    width: 45.7631,
    height: 15.0703,
    rx: 1,
    transform: "rotate(-47.4489 176.125 138.213)",
    fill: "#CF7E7E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.072 137.987C117.258 137.24 117.204 135.975 117.951 135.161L129.203 122.904C129.95 122.09 131.216 122.036 132.029 122.783L206.366 191.022C207.18 191.769 207.234 193.035 206.487 193.848L195.235 206.106C194.488 206.92 193.223 206.974 192.409 206.227L118.072 137.987Z",
    fill: "#347E8D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.365 191.019L142.078 132.005L196.898 204.291L206.486 193.845C207.233 193.031 207.179 191.766 206.365 191.019Z",
    fill: "#245F6B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.667 161.038C111.853 160.291 111.799 159.026 112.546 158.212L125.151 144.481L185.335 199.729L172.73 213.46C171.983 214.274 170.718 214.328 169.904 213.581L112.667 161.038Z",
    fill: "#347E8D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.968 53.1738L221.573 39.4427C222.32 38.629 223.585 38.5749 224.398 39.3219L281.636 91.8646C282.45 92.6115 282.504 93.8767 281.757 94.6904L269.152 108.422L208.968 53.1738Z",
    fill: "#347E8D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.933 61.8818C187.12 61.1348 187.065 59.8697 187.812 59.0559L199.065 46.7982C199.812 45.9845 201.077 45.9304 201.891 46.6773L276.228 114.917C277.042 115.664 277.096 116.929 276.349 117.743L265.096 130.001C264.349 130.814 263.084 130.868 262.271 130.121L187.933 61.8818Z",
    fill: "#347E8D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.33 199.727L130.872 149.735L174.389 211.646L185.33 199.727Z",
    fill: "#245F6B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.269 130.123L197.982 71.1083L274.684 119.556L265.095 130.002C264.348 130.815 263.083 130.869 262.269 130.123Z",
    fill: "#245F6B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.149 108.416L214.691 58.4247L280.09 96.4974L269.149 108.416Z",
    fill: "#245F6B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.34 242.453V222.656H190.105C194.604 222.656 197.188 225.432 197.188 229.328C197.188 233.279 194.562 236 189.996 236H186.441V242.453H182.34ZM186.441 232.691H189.34C191.773 232.691 192.963 231.324 192.949 229.328C192.963 227.359 191.773 226.033 189.34 226.02H186.441V232.691ZM201.152 242.699C199.867 242.699 198.828 241.674 198.855 240.402C198.828 239.145 199.867 238.119 201.152 238.133C202.369 238.119 203.422 239.145 203.422 240.402C203.422 241.674 202.369 242.699 201.152 242.699ZM206.758 242.453V222.656H214.523C219.021 222.656 221.605 225.432 221.605 229.328C221.605 233.279 218.98 236 214.414 236H210.859V242.453H206.758ZM210.859 232.691H213.758C216.191 232.691 217.381 231.324 217.367 229.328C217.381 227.359 216.191 226.033 213.758 226.02H210.859V232.691ZM228.168 222.656V242.453H224.121V222.656H228.168ZM238.039 242.754C233.486 242.74 230.697 239.801 230.711 235.098C230.697 230.518 233.527 227.414 237.875 227.414C241.771 227.414 244.848 229.875 244.848 234.934V236.082H234.703C234.703 238.324 236.029 239.705 238.121 239.719C239.502 239.705 240.486 239.104 240.883 238.215H244.738C244.164 240.963 241.703 242.74 238.039 242.754ZM234.703 233.539H241.02C241.006 231.734 239.762 230.436 237.957 230.449C236.098 230.436 234.785 231.83 234.703 233.539Z",
    fill: "black"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMiniExercise01);
export default __webpack_public_path__ + "static/media/mini_exercise_01.5862f1b1187ef1fbc9374bb04a400f38.svg";
export { ForwardRef as ReactComponent };